/**
 * Cambio di location
 * @param {*} url
 */
const setLocation = (url) => {
  window.location = url;
};

/**
 * Funzione che rimuove il "#" dall'hash passato in input
 * @param {*} hash
 * @returns hash cleaned
 */
const getHashCleaned = (hash) => (hash ? hash.replace('#', '') : hash);

/**
 * Cambio di hash
 * @param {*} hash
 * @param {*} replaceHistory
 */
const setLocationHash = (hash, replaceHistory = true) => {
  if (getHashCleaned(window.location.hash) === getHashCleaned(hash)) return;
  const queryPos = window.location.hash ? window.location.hash.indexOf('?') : -1;
  const query = queryPos > 0 ? window.location.hash.substring(queryPos) : '';
  window.location.hash = hash + query;
  if (replaceHistory) {
    window.history.replaceState({}, document.title, hash + query);
  }
};

/**
 * Funzione che ritorna i parametri querystring della location
 * corrente
 */
const getUrlParams = () => {
  const params = {};
  if (window.location && window.location.href) {
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      (m, key, value) => { params[key] = value; });
  }
  return params;
};

/**
 * Funzione che serializza i parametri dall'oggetto passato in input filtrando gli undefined
 * @param {*} srcParams
 */
const getQueryParamsFromObject = (srcParams) => (srcParams ? `&${Object.keys(srcParams)
  .filter((p) => srcParams[p] !== undefined)
  .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(srcParams[k])}`).join('&')}` : '');

export {
  setLocation,
  setLocationHash,
  getUrlParams,
  getQueryParamsFromObject,
  getHashCleaned,
};
